import { useState } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { checkUrl, CheckUrlResponse } from '../services/api';
import { Results } from '../components/Results';
import LanguageSwitcher from '../components/LanguageSwitcher';

export function Lookup() {
  const { t } = useTranslation();
  const [url, setUrl] = useState('');
  const [deep, setDeep] = useState(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<CheckUrlResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!url) return;

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await checkUrl({ url, deep });
      setResult(response);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unknown error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="content-wrapper--narrow">
        <div className="mb-4 flex items-center justify-end">
          <LanguageSwitcher />
        </div>
        <h1 className="page-title">{t('lookup.title')}</h1>

        <form onSubmit={handleSubmit} className="card mb-6">
          <label htmlFor="url-input" className="form-label">
            {t('lookup.placeholder')}
          </label>
          <input
            id="url-input"
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://example.com"
            className="input-field-compact"
            required
          />

          <div className="mt-4">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={deep}
                onChange={(e) => setDeep(e.target.checked)}
                className="mr-2"
              />
              <span className="text-sm text-gray-700">{t('lookup.deepAnalysis')}</span>
            </label>
            {deep && (
              <p className="text-xs text-gray-500 mt-1 ml-6">{t('lookup.consent')}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary mt-6 w-full"
          >
            {loading ? t('common.loading') : t('lookup.submit')}
          </button>
        </form>

        {error && (
          <div className="alert-error mb-6">
            {t('common.error')}: {error}
          </div>
        )}

        {result && <Results result={result} />}
      </div>
    </div>
  );
}
